var _defs, _defs2, _g, _path, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPrizmaticlogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 119.7 115.49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2176"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M-21.668-224.99L6.438-334.12h73.149l16.177 4.092-16.035 59.196H31.796l-13.347 49.935h-23.94z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2260"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.265,
    d: "M-172.8-322.67h129.7v125.49h-129.7zm71.218 30.803l-2.818 10.079 4.525.012 2.69-10.08z",
    className: "powerclip"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath2260)",
    transform: "translate(167.79 317.67)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath2176)",
    transform: "translate(-144.99 17.586)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.04-337.34h17.198-158.22zM125.41-337.34h38.63H23.02zM86.254-337.34h39.158-102.39zM51.064-337.34h35.19-63.235z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9206cb",
    d: "M164.04-337.34l17.198 28.046v-28.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f60d11",
    d: "M-24.077-309.3l47.096-28.046h-47.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c70d63",
    d: "M51.064-337.34l26.988 40.482 8.202-40.482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a00baa",
    d: "M137.05-290.78l26.988-46.567h-38.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#900fc1",
    d: "M137.05-290.78l44.186-18.521-17.198-28.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ec211d",
    d: "M-24.077-309.3l38.894 23.019 8.202-51.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bb0c7b",
    d: "M78.052-296.86l47.36-40.482H86.254z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd1238",
    d: "M14.817-286.28l36.248-51.065H23.019z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7340b",
    d: "M-24.077-288.13l38.894 1.852-38.894-23.019z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a91691",
    d: "M78.052-296.86l59.002 6.085-11.642-46.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#801bcd",
    d: "M137.05-290.78l44.186 2.646v-21.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8235b",
    d: "M51.064-337.34l.265 66.675 26.723-26.193z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d62942",
    d: "M14.817-286.28l36.512 15.61-.265-66.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2308d",
    d: "M106.63-258.5l30.427-32.279-59.002-6.085z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d34740",
    d: "M28.31-250.03l23.019-20.638-36.512-15.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5490f",
    d: "M-24.077-249.24l38.894-37.042-38.894-1.852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b5376f",
    d: "M51.329-270.67l55.298 12.171-28.575-38.364z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7a26c9",
    d: "M137.05-290.78l44.186 41.54v-38.894z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a3aa5",
    d: "M106.63-258.5l32.015 24.606-1.588-56.885z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e45327",
    d: "M-24.077-249.24l52.388-.794-13.494-36.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6574e",
    d: "M28.31-250.03l29.369 16.669-6.35-37.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7a34bd",
    d: "M138.64-233.89l42.598-15.345-44.186-41.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b45067",
    d: "M57.679-233.36l48.948-25.136-55.298-12.171z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e36c25",
    d: "M-24.077-249.24L9.26-225.957l19.05-24.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7951ad",
    d: "M110.33-208.49l28.311-25.4-32.015-24.606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4840e",
    d: "M-24.077-202.67L9.26-225.953l-33.337-23.283z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce6940",
    d: "M9.26-225.95l48.42-7.408-29.37-16.669z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d5b7f",
    d: "M57.679-233.36l52.652 24.87-3.704-50.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5143df",
    d: "M138.64-233.89l42.598 31.221v-46.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e7276",
    d: "M59.002-202.67l51.329-5.821-52.652-24.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c0764e",
    d: "M9.26-225.95l49.742 23.283-1.323-30.691z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86758f",
    d: "M59.002-202.67l30.427 20.638 20.902-26.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d38635",
    d: "M28.84-180.98l30.162-21.696L9.26-225.959z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4658db",
    d: "M138.64-233.89l10.848 63.5 31.75-32.279z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7260ac",
    d: "M110.33-208.49l39.159 38.1-10.848-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e49520",
    d: "M-24.077-202.67l52.917 21.696-19.579-44.979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#335cea",
    d: "M149.49-170.39l31.75-4.498v-27.781z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8d71",
    d: "M59.531-165.89l29.898-16.139-30.427-20.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b19a58",
    d: "M28.84-180.98l30.692 15.081-.53-36.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0b011",
    d: "M-24.077-174.89l52.917-6.085-52.917-21.696z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d75a7",
    d: "M89.429-182.03l60.061 11.641-39.159-38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ca37b",
    d: "M59.531-165.89l26.723 33.867 3.175-50.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2879e4",
    d: "M164.04-132.03l17.198-42.863-31.75 4.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d8bae",
    d: "M89.429-182.03l35.983 50.006 24.078-38.365z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b7ff7",
    d: "M164.04-132.03h17.198v-42.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b7b44d",
    d: "M23.019-132.03l36.512-33.867-30.692-15.081z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aac255",
    d: "M23.019-132.03h28.046l8.467-33.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9c129",
    d: "M-24.077-174.89l47.096 42.863 5.82-48.948z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70a295",
    d: "M86.254-132.03h39.158l-35.983-50.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96b86d",
    d: "M51.064-132.03h35.19l-26.723-33.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#288cda",
    d: "M125.41-132.03h38.63l-14.552-38.365z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eedf12",
    d: "M-24.077-132.03h47.096l-47.096-42.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-24.077-132.03h75.142-28.046z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.268
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M-150.486-203.316l-16.177-4.092 28.106-109.13",
    style: {
      mixBlendMode: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-122.38-312.446l-16.177-4.092"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-49.232-312.446l-16.177-4.092M-138.558-316.536h73.15M-150.486-203.316l28.106-109.13h73.149l-16.035 59.196h-47.933l-13.347 49.935z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 7.408
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeWidth: 2.26773696,
    d: "M-107.048-276.555l4.622-16.44h24.02l-4.405 16.44zM-98.988-280.647l3.309-12.348z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.26773696,
    d: "M-82.81-276.555l-16.178-4.092"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeWidth: 2.26773696,
    d: "M-98.988-280.647h-6.963"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrizmaticlogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/prizmaticlogo.39d492d4.svg";
export { ForwardRef as ReactComponent };